export enum SortingEnum {
  ASCENDING = 'ASC',
  DESCENDING = 'DESC',
  NONE = ''
}

/**
 * Info about the current sorting state of a column. Contains information about the direction in
 * which it is sorted and its sortIndex (priority of this column in the sorting algorithm,
 * displayed as a number next to the sort-icon, see BLS-4618).
 */
export interface SortingState {
  sortDirection: SortingEnum,
  sortIndex: number
}